import React from 'react';
import "./featured.css";

const Featured = () => {
  return (
    <section className='featured'>
      <div className='container'>
        <h2>
          <span className="support">Support</span> me to Travel more .... <br />
          And  create more vlogs for You..<br />  Your Support really help me to <br></br>  keep my
        <span className="art-alive"> art alive ..</span>
        </h2>
      </div>
    </section>
  );
}

export default Featured;
